export let logs: string[] = [];

export function logMessage(message: string) {
  // Add the timestamp to the message
  const timestamp = new Date().toISOString();
  console.log(`${timestamp}: ${message}`);
  logs.push(`${timestamp}: ${message}`);
}
